import { Component } from 'react'

export default class CodeDetails extends Component {
  render() {
    return (
      <div>CodeDetails</div>
    )
  }
}
